// extracted by mini-css-extract-plugin
export var container = "ContactUs-module--container--8d01d";
export var layout = "ContactUs-module--layout--6a299";
export var content = "ContactUs-module--content--ce9c2";
export var title = "ContactUs-module--title--d0c3d";
export var formWrapper = "ContactUs-module--formWrapper--f6f44";
export var animation = "ContactUs-module--animation--5e076";